<template>

    <!-- Dashboard Content
      ================================================== -->
    <div class="dashboard-content-container" data-simplebar>
        <div class="dashboard-content-inner">
            <!-- Dashboard Headline -->
            <div class="dashboard-headline">
                <h3>Regions</h3>

                <!-- Breadcrumbs -->
                <nav id="breadcrumbs" class="dark">
                    <ul>
                        <li><a href="/admin">Admin</a></li>
                        <li><a href="/admin/locations/countries">Locations</a></li>
                        <li>Regions</li>
                    </ul>
                </nav>
            </div>

            <!-- Dashboard Box -->
            <div class="col-xl-12">
                <div class="dashboard-box margin-top-0">
                    <!-- Headline -->
                    <div class="headline">
                        <search
                            placeholder= "Search for Regions"
                            icon="location-on"
                            min_len = '3'
                            v-on:searchstr="searchForRegions($event)">

                        </search>

                    </div>

                </div>

                <br/>
                <div class="row">
                    <div class="dashboard-box margin-top-0" :class="layoutClass">
                        <!-- Headline -->
                        <div class="content">
                            <p class="search-info" v-text="searchInfo"></p>
                            <ul class="dashboard-box-list" v-if="visibleRegions.length > 0">
                                <li v-for="(region, i) in visibleRegions" :key="i">
                                    <!-- Job Listing -->
                                    <div class="job-listing">

                                        <!-- Job Listing Details -->
                                        <div class="job-listing-details">

                                            <!-- Logo -->
                                            <a href="#" class="job-listing-company-logo">
                                                <i class="icon-material-outline-location-city"></i>
                                            </a>

                                            <!-- Details -->
                                            <div class="job-listing-description">
                                                <h3 class="job-listing-title">
                                                    <span class="country-name" v-text="region.name"></span>
                                                </h3>

                                                <div class="job-listing-footer">
                                                    <ul>
                                                        <li><a :href="'/admin/location/cities?region=' + region.id" v-on:click.prevent="viewCities(region)"><i class="icon-material-outline-location-city"></i> View Cities</a></li>
                                                        <li><a :href="'/admin/location/users?region=' + region.id" v-on:click.prevent="viewUsers(region)"><i class="icon-material-outline-group"></i> View Users</a></li>
                                                        <li><a :href="'/admin/location/projects?region=' + region.id" v-on:click.prevent="viewProjects(region)"><i class="icon-material-outline-business-center"></i> View Projects</a></li>
                                                    </ul>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <loader v-if="visibleRegions.length < 1 && searchInfo === ''"></loader>
                            <div style="text-align: center;">
                                <button class="button ripple-effect" v-if="this.visibleRegions.length < this.regions.length" v-on:click.prevent="loadRegions()">
                                    Load More
                                </button>
                            </div>
                            <br/>
                            <br/>
                        </div>

                    </div>

                    <div class="dashboard-box margin-top-0 col-xl-6" v-if="currentUsersRegion !== 0">
                        <users :region="currentUsersRegion" :key="currentUsersKey">
                        </users>

                    </div>

                    <div class="dashboard-box margin-top-0 col-xl-6" v-if="currentProjectsRegion !== 0">
                        <projects-list :region="currentProjectsRegion" :key="currentProjectsKey">
                        </projects-list>

                    </div>
                    <div class="dashboard-box margin-top-0 col-xl-6" v-if="currentCitiesRegion !== 0">
                        <cities :region="currentCitiesRegion" :key="currentCitiesKey">
                        </cities>

                    </div>

                </div>
            </div>
        </div>

        <!--            <app-footer></app-footer>-->
    </div>
    <!-- Dashboard Content / End -->

</template>

<script>
    import {getRegions} from '../../../../core/services/location-services'
    import Search from "../../../partials/Search";
    import Loader from "../../../partials/Loader";
    import Users from "./Users";
    import ProjectsList from "./ProjectsList";
    import Cities from "./Cities";

    export default {
        name: 'Countries',
        components: {Cities, Users, ProjectsList, Loader, Search},
        data() {
            return {
                regions: [],
                visibleRegions: [],
                paginationSize: 10,
                currentPage: 0,
                searchInfo: '',
                twoPaneLimit: 1200,
                currentUsersRegion: 0,
                currentProjectsRegion: 0,
                currentCitiesRegion: 0,
                currentUsersKey: 0,
                currentProjectsKey: 2,
                currentCitiesKey: 4,
                layoutClass: 'col-xl-12',
            }
        },

        computed: {
        },
        methods: {
            populateRegions() {
                getRegions()
                    .then((regions) => {
                        this.regions = regions;
                        this.loadRegions();
                    })
                    .catch(() => {
                        // console.log(error);
                    })
                    .finally(() => {

                    });

            },

            loadRegions() {
                // Use currentPage property to get index and then increment it after use
                // let start = (this.currentPage++ * this.paginationSize);
                let end = (++this.currentPage * this.paginationSize);
                this.visibleRegions =
                    this.regions.slice(
                        0,
                        end
                    );
            },

            searchForRegions(str) {
                this.searchInfo = '';
                this.visibleRegions = [];
                if(str.length === 0) {
                    this.currentPage = 0;
                    this.populateRegions();
                } else {
                    let matchedRegions = [];
                    this.regions.forEach((region) => {
                        if((region.name.toLowerCase().search(str.toLowerCase())) !== -1) {
                            matchedRegions.push(region)
                        }
                    });

                    this.visibleRegions =  matchedRegions;
                }
            },

            viewUsers(region) {
                this.currentRegionsCountry = 0;
                this.currentProjectsCountry = 0;
                this.currentCitiesRegion = 0;
                this.currentUsersKey++;
                if(window.innerWidth >= this.twoPaneLimit) {
                    this.layoutClass = 'col-xl-6';
                    this.currentUsersRegion = region;
                } else {
                    this.$router.push(`/admin/location/users?region=${region.id}`);
                }
            },
            viewProjects(region) {
                this.currentRegionsCountry = 0;
                this.currentUsersRegion = 0;
                this.currentCitiesRegion = 0;
                this.currentProjectsKey++;
                if(window.innerWidth >= this.twoPaneLimit) {
                    this.layoutClass = 'col-xl-6';
                    this.currentProjectsRegion = region;
                } else {
                    this.$router.push(`/admin/location/projects?region=${region.id}`);
                }
            },
            viewCities(region) {
                this.currentRegionsCountry = 0;
                this.currentUsersRegion = 0;
                this.currentProjectsRegion = 0;
                this.currentCitiesKey++;
                if(window.innerWidth >= this.twoPaneLimit) {
                    this.layoutClass = 'col-xl-6';
                    this.currentCitiesRegion = region;
                } else {
                    this.$router.push(`/admin/location/projects?country=${region.id}`);
                }
            },
        },

        created() {
            this.populateRegions();
        }
    };
</script>

<style scoped>
    .country-info {
        font-size: .7rem;
        color: #0fbaf1 !important;
    }
    .country-name {
        text-transform: uppercase;
        color: black;
    }
    .country-name::after {
        content: " ";
    }
    .search-info {
        margin: 0 auto;
        text-align: center;
        color: #0fbaf1 !important;
    }

    button {
        line-height: 0.5rem !important;
    }
</style>
